module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar_block"
  }, [_c('CalendarHeader', {
    attrs: {
      "days": _vm.days
    }
  }), _c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.loading,
      "size": 100
    }
  }, [_c('CalendarBody', {
    attrs: {
      "data": _vm.data,
      "days": _vm.days
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68924714","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/CalendarBlock.vue
// module id = 15bbaf33289d86a08c29
// module chunks = 5